import { Copy } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { useRef } from "react";
import { toast } from "sonner";

import type { Contract } from "@/types/contract";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

interface ContractInvoiceProps {
	contract: Contract;
}

export default function ContractInvoiceDialog({
	contract
}: ContractInvoiceProps) {
	const printRef = useRef<HTMLDivElement>(null);
	// const originalContents = useRef<string>("");
	// const [open, setOpen] = useState(false);
	const handleCopy = async () => {
		await navigator.clipboard.writeText(contract.contractCode);
		toast.success("Contract ID copied to clipboard");
	};

	const handleSave = () => {
		// Implement save to device functionality
		console.log("Saving to device...");
	};

	const handlePrint = () => {
		// setOpen(false);
		// if (printRef.current) {
		// 	const printContents = printRef.current.innerHTML;
		// 	originalContents.current = document.body.innerHTML;
		// 	document.body.innerHTML = printContents;
		// 	window.print();
		// 	document.body.innerHTML = originalContents.current;
		// }
	};
	return (
		<Dialog>
			<DialogTrigger asChild>
				<Button variant="accent">View contract invoice</Button>
			</DialogTrigger>
			<DialogContent className="max-w-md">
				<DialogHeader>
					<DialogTitle className="text-center">Contract Invoice</DialogTitle>
				</DialogHeader>
				<div ref={printRef} className="flex flex-col items-center space-y-4">
					{/* QR Code */}
					<div className="relative">
						<QRCodeSVG
							value={contract.contractCode}
							size={200}
							bgColor="#ffffff"
							fgColor="#000000"
							imageSettings={{
								src: "/intasida-icon.svg",
								x: undefined,
								y: undefined,
								height: 24,
								width: 24,
								opacity: 1,
								excavate: true
							}}
						/>
					</div>

					{/* Instructions */}
					<div className="text-center space-y-1">
						<p className="text-base">Scan the QR code above or copy the Contract ID.</p>
						<p className="text-sm text-gray-500">It will be used both during item drop-off and pickup</p>
					</div>

					{/* Contract Invoice */}
					<div className="w-full p-6 bg-gray-50 rounded-lg space-y-4">
						<div>
							<p className="text-sm text-gray-500">Contract ID</p>
							<div className="flex items-center justify-between">
								<p className="text-lg font-medium">{contract.contractCode}</p>
								<Button
									variant="ghost"
									size="sm"
									onClick={handleCopy}
									className="text-primary"
								>
									<span className="mr-2">COPY ID</span>
									<Copy className="h-4 w-4" />
								</Button>
							</div>
						</div>

						<div>
							<p className="text-sm text-gray-500">Contract name</p>
							<p className="text-lg font-medium">{contract.title}</p>
						</div>

						<div>
							<p className="text-sm text-gray-500">Pickup location</p>
							<p className="text-lg font-medium">missing</p>
						</div>

						<div>
							<p className="text-sm text-gray-500">Intasida agent</p>
							<p className="text-lg font-medium">missing</p>
						</div>
					</div>
				</div>

				{/* Action Buttons */}
				<div className="w-full grid grid-cols-2 gap-4 mt-4">
					<Button className="w-full" onClick={handleSave}>
						Save to device
					</Button>
					<Button
						variant="outline"
						className="w-full text-primary border-primary hover:bg-purple-50 hover:text-primary"
						onClick={handlePrint}
					>
						Print this copy
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
